import React from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SchoolIcon from '@mui/icons-material/School';

/**
 * Aviso cuando el estudiante debe completar el curso de bienvenida.
 */
const WelcomeCourseBanner = ({
  courseId,
  courseTitle,
  sx = {},
}) => {
  const navigate = useNavigate();

  if (!courseId) return null;

  const goToWelcome = () => {
    navigate(`/courses/Introcourse/${courseId}`, { state: { objeto: courseId } });
  };

  return (
    <Box sx={{ mb: 2, ...sx }}>
      <Alert
        severity="warning"
        icon={<SchoolIcon />}
        action={
          <Button
            color="inherit"
            size="small"
            variant="outlined"
            onClick={goToWelcome}
            sx={{
              whiteSpace: 'nowrap',
              borderColor: 'rgba(0,0,0,0.23)',
              fontWeight: 600,
              textTransform: 'none',
            }}
          >
            Ir al curso
          </Button>
        }
        sx={{
          borderRadius: 2,
          alignItems: 'center',
          bgcolor: 'rgba(245, 158, 11, 0.12)',
          border: '1px solid rgba(245, 158, 11, 0.35)',
          '& .MuiAlert-message': { flex: 1 },
        }}
      >
        <AlertTitle sx={{ fontWeight: 700, mb: 0.25 }}>
          Curso de bienvenida obligatorio
        </AlertTitle>
        Debes completar el curso de bienvenida
        {courseTitle ? ` «${courseTitle}»` : ''} antes de acceder a otros cursos.
      </Alert>
    </Box>
  );
};

export default WelcomeCourseBanner;
